import {
  DOCUMENT_CATEGORY_OPTIONS,
  type DocumentCategory,
} from '@seen/core/models/document-references/constants'
import { Badge } from '@seen/ui'
import type { JSX } from 'react'

interface CategoryBadgeProps {
  category: DocumentCategory
  className?: string
}

export function CategoryBadge({
  category,
  className,
}: CategoryBadgeProps): JSX.Element {
  const option = DOCUMENT_CATEGORY_OPTIONS.find((opt) => opt.value === category)

  return (
    <Badge variant="outline" className={className}>
      {option?.label ?? category}
    </Badge>
  )
}
